import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../../components/form'
import { fetchWrapper } from '../../../../helpers';
import { LuArrowLeftCircle } from "react-icons/lu";

function Create({ getPage, channel_id }) {
	const [customerList, setCustomerList] = useState([])


	const [formData, setFormData] = useState({
		account_name: '',
		customer_id: '',
		host: '',
		username: '',
		password: '',
		port: '',
		from_name:'',
		from_address: '',
		status_id: '',


	});

	const FormSchema = Yup.object().shape({
		account_name: Yup.string()
			.required('Account name is required')
			.min(3, 'Account name must be at least 3 characters')
			.max(50, 'Account name must be less than 50 characters'),

		customer_id: Yup.string()
			.required('Customer selection is required'),

		host: Yup.string()
			.required('Host is required')
			.test('is-valid-host', 'Please enter a valid host name or IP address', value => {
				// Basic validation for hostnames and IP addresses
				return /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$|^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value);
			}),

		port: Yup.number()
			.typeError('Port must be a number')
			.required('Port is required')
			.integer('Port must be an integer')
			.min(1, 'Port must be at least 1')
			.max(65535, 'Port must be less than or equal to 65535'),

		
		from_name: Yup.string()
					.required('From name is required'),
					
		from_address: Yup.string()
					.required('Sending email address is required')
					.test('is-valid-email', 'Please enter a valid email address ', value => {
						return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
					}),

		username: Yup.string()
			.required('Username is required')
			.min(3, 'Username must be at least 3 characters')
			.max(100, 'Username must be less than 100 characters'),

		password: Yup.string()
			.required('Password is required')
			.min(6, 'Password must be at least 6 characters')
			.matches(
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/,
				'Password must contain at least one uppercase letter, one lowercase letter, and one number'
			),

		status_id: Yup.string()
			.required('Status selection is required'),
	});


	useEffect(() => {
		loadCustomerList()
	}, [])


	const loadCustomerList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const response = await fetchWrapper.get(url)
		const customerList = response.data;

		const allCustomersEntry = { id: 0, name: "All Customers" };


		const updatedData = [allCustomersEntry, ...customerList];
		let data = updatedData?.map(item => ({ id: item.id, name: item.business_name || item.name }))
		const db = { data: data };
		setCustomerList(db);
	}










	const statusList = {
		data: [
			{ id: '1', name: 'Active' },
			{ id: '0', name: 'InActive' }
		]
	};


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values


		const api_config = {
			host: data.host,
			username: data.username,
			password: data.password,
			port: data.port,
			from_address: data.from_address,
			from_name:data?.from_name

		}


		const postData = {
			customer_id: data.customer_id,
			status_id: data.status_id,
			channel_id: channel_id,
			api_config: api_config,
			account_name: data.account_name,
		}

		const url = `${process.env.REACT_APP_API_URL}/channel_api_config/create`;
		await fetchWrapper.post(url, postData)

		getPage('list', channel_id);

	}

	return (

		<div className="setting_detail_section">

			<HStack>
				<Box>
					<LuArrowLeftCircle style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => getPage('list', channel_id)} />
				</Box>
				<Box>
					<h2 className="main_heading">Add E-mail Account</h2>
				</Box>
			</HStack>
			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>


				<InputText name="account_name" title="Account Name" inputProps={{ isRequired: true }} placeholder="Please Enter Account Name" />
				<SelectField name="customer_id" title="Customers" list={customerList} />

				<InputText name="host" title="Host" inputProps={{ isRequired: true }} placeholder="Please Enter Host" />

				<InputText name="port" title="Port" inputProps={{ isRequired: true }} placeholder="Please Enter Port" />

				<InputText name="from_name" title="From Name" inputProps={{ isRequired: true,  }} placeholder="Please Enter From Name" />

				<InputText name="from_address" title="Sending Email Address" inputProps={{ isRequired: true,  }} placeholder="Please Enter Sending Email" />


				<InputText name="username" title="Username" inputProps={{ isRequired: true }} placeholder="Please Enter User Name" />
				<InputText name="password" title="Password" inputProps={{ isRequired: true, type: "password" }} placeholder="Please Enter Password" />


				<Box w="30%">
					<SelectField name="status_id" title="Status" list={statusList} />
				</Box>




				<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
					mb={4}

					type='submit'
				>
					Add E-mail Account
				</Button>
			</Form>
		</div>


	)
}

export default Create;